import { gql } from '@apollo/client';

export const GET_ALL_MULAN_FCT_WEEK_REGISTRATIONS = gql`
  query GetAllMulanFctWeekRegistrations(
    $page: Float
    $pageSize: Float
    $status: String
    $searchTerm: String
  ) {
    getAllMulanFctWeekRegistrations(
      page: $page
      pageSize: $pageSize
      status: $status
      searchTerm: $searchTerm
    ) {
      registrations {
        _id
        name
        email
        mobile
        whatsapp
        scn
        category
        amount
        status
        receiptNumber
        created_at
        paymentDetails {
          _id
          transactionId
          status
          amount
          currency
        }
      }
      pageInfo {
        currentPage
        pageSize
        totalPages
        totalItems
        hasNextPage
        hasPrevPage
        nextPage
        prevPage
      }
    }
  }
`;

export const GET_MULAN_FCT_WEEK_REGISTRATION_BY_ID = gql`
  query GetMulanFctWeekRegistrationById($id: String!) {
    getMulanFctWeekRegistrationById(id: $id) {
      _id
      name
      email
      mobile
      whatsapp
      scn
      category
      amount
      status
      receiptNumber
      created_at
      paymentDetails {
        _id
        transactionId
        status
        amount
        currency
      }
    }
  }
`;

export const RESOLVE_MULAN_FCT_WEEK_PAYMENT = gql`
  mutation ResolveMulanFctWeekPayment($input: MulanFctWeekPaymentResolutionInput!) {
    resolveMulanFctWeekPayment(input: $input) {
      _id
      amount
      status
      serviceId
      transactionId
    }
  }
`;

